module.exports = __webpack_public_path__ + "images/f8a16802dc0cef740132e79ce97f04f8.svg";